/**
 * Created by carlhaynes on 9/25/17.
 */
import React, { Component } from 'react';
import '../App.css';
import { Button, ButtonToolbar, Grid, Row, PageHeader } from 'react-bootstrap';

class About extends Component {

  render() {
    const buttonsInstance = (
      <ButtonToolbar>
        {/* Standard button */}
        <Button>Default</Button>

        {/* Provides extra visual weight and identifies the primary action in a set of buttons */}
        <Button bsStyle="primary" href="/topics">Primary</Button>

        {/* Indicates a successful or positive action */}
        <Button bsStyle="success">Success</Button>

        {/* Contextual button for informational alert messages */}
        <Button bsStyle="info">Info</Button>

        {/* Indicates caution should be taken with this action */}
        <Button bsStyle="warning">Warning</Button>

        {/* Indicates a dangerous or potentially negative action */}
        <Button bsStyle="danger">Danger</Button>

        {/* Deemphasize a button by making it look like a link while maintaining button behavior */}
        <Button bsStyle="link">Link</Button>
      </ButtonToolbar>
    );


    return (
          <Grid>
              <Row>
                  <PageHeader>About</PageHeader>
              </Row>
              <Row>
                  {buttonsInstance}
              </Row>
          </Grid>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.jsx